import { DateTime } from 'luxon';

import { dateIsCurrentYear } from 'common/utils/formatDate';

/**
 * Check if the end date is near. Within a month of the current year and in the future.
 *
 * @param endDateISO string
 * @returns boolean
 */
export function receivedCertificateEndDateNear(endDateISO: string) {
    const endDate = DateTime.fromISO(endDateISO);

    return !!(
        dateIsCurrentYear(endDate) &&
        endDate > DateTime.now() &&
        endDate.diffNow('month').months < 1
    );
}
